import styled from 'styled-components'
import { Stop } from '@styled-icons/octicons/Stop'

export const ModalContent = styled.div`
  padding: 20px;
`

export const ContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
`

export const NoteText = styled.p`
  font-size: 12px !important;
  color: red;
  opacity: 0.8;
  margin: 5px;
`

export const MessageContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
  flex-direction: column;
  p {
    font-size: 16px;
    margin-bottom: 10px;
    text-align: center;
  }
`

export const AlertIcon = styled(Stop)`
  color: yellow;
  width: 48px;
  margin: 10px;
`
